//@flow
import React from "react";

type Props = {
  quantity: number,
  schoolName: string,
  disableFields: string,
  buttonText: string,
  handleSubmit: (e: SyntheticEvent<HTMLFormElement>) => mixed,
  handleChange: (e: SyntheticEvent<HTMLInputElement>) => mixed
};

const InvoiceForm = (props: Props) => {
  return (
    <div className="invoice-form">
      <p>
        Please submit the following information and an invoice and vouchers will
        be generated for you within 24 hours.
      </p>

      <p>
        The invoice that will be generated is for fees associated with the Ohio Student Disclosure Course that is required by Ohio State Board of Career Colleges and Schools (OSBCCS) in accordance with Ohio Administrative Code section 3332-1-09(C).
        All schools with outstanding invoices beyond 30 days will be sent a reminder of the outstanding invoice and their school will be reported to the OSBCCS. 
        For schools with outstanding invoices beyond 60 days, OSBCCS will be notified of the delinquent account and the school may be subject to further disciplinary action by OSBCCS.
      </p>

      <form className="form" onSubmit={props.handleSubmit.bind(this)}>
        <div className="form-group">
          <label className="mb-2 mr-sm-2 mb-sm-0" htmlFor="school_name">
            School Name
          </label>
          <div className="input-group">
            <input
              className="form-control"
              id="school_name"
              required="required"
              type="text"
              value={props.schoolName}
              name="school_name"
              disabled="disabled"
            />
          </div>
        </div>

        <div className="form-group">
          <label
            className="mb-2 mr-sm-2 mb-sm-0"
            htmlFor="accounting_contact_name"
          >
            Accounting Contact Name
          </label>
          <div className="input-group">
            <input
              className="form-control"
              id="accounting_contact_name"
              required="required"
              type="text"
              name="accounting_contact_name"
              onChange={props.handleChange.bind(this)}
              disabled={props.disableFields}
            />
          </div>
        </div>

        <div className="form-group">
          <label
            className="mb-2 mr-sm-2 mb-sm-0"
            htmlFor="accounting_contact_email"
          >
            Accounting Contact Email
          </label>
          <div className="input-group">
            <input
              className="form-control"
              id="accounting_contact_email"
              required="required"
              type="email"
              name="accounting_contact_email"
              onChange={props.handleChange.bind(this)}
              disabled={props.disableFields}
            />
          </div>
        </div>

        <div className="form-group">
          <label
            className="mb-2 mr-sm-2 mb-sm-0"
            htmlFor="invitation_administrator_email"
          >
            Invitation Administrator Contact Email
          </label>
          <div className="input-group">
            <input
              className="form-control"
              id="invitation_administrator_email"
              required="required"
              type="email"
              name="invitation_administrator_email"
              onChange={props.handleChange.bind(this)}
              disabled={props.disableFields}
            />
          </div>
        </div>

        <div className="form-group">
          <label className="mb-2 mr-sm-2 mb-sm-0" htmlFor="quantity">
            Quantity
          </label>
          <div className="input-group">
            <input
              className="form-control"
              id="quantity"
              required="required"
              type="text"
              value={props.quantity}
              name="quantity"
              disabled="disabled"
            />
            <span className="input-group-btn">
              <input
                type="submit"
                id="submit_invoice"
                value={props.buttonText}
                className="btn btn-success"
                disabled={props.disableFields}
              />
            </span>
          </div>
        </div>
      </form>
    </div>
  );
};

export default InvoiceForm;



// WEBPACK FOOTER //
// ./app/javascript/order_form/components/invoice_form.jsx